import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';

export const PaymentDialog = ({
  open,
  paymentAmount,
  paymentLoading,
  onOpenChange,
  onPaymentAmountChange,
  onCancel,
  onSave,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Registrar Pago</DialogTitle>
          <DialogDescription>Ingresa el monto pagado para esta propiedad</DialogDescription>
        </DialogHeader>
        <div className="grid w-full gap-4 py-4">
          <div className="grid gap-2">
            <Label htmlFor="payment-amount">Monto (EUR)</Label>
            <Input
              id="payment-amount"
              placeholder="0"
              type="number"
              step="1"
              min="0"
              value={paymentAmount}
              onChange={(event) => onPaymentAmountChange(event.target.value)}
              disabled={paymentLoading}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={paymentLoading}>Cancelar</Button>
          <Button onClick={onSave} disabled={paymentLoading} className="bg-blue-600 hover:bg-blue-700">
            {paymentLoading ? 'Guardando...' : 'Guardar Pago'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
